import { axiosPrivate, getLocale } from ".";

export const fetchCategories = async () => {
  return await axiosPrivate.post("/loja/produto/categoria/listar", {
    lang: getLocale(),
    get_traduzido: true,
  });
};

export const changeWebTax = async idproduto => {
  return await axiosPrivate.put(`/loja/155/produto/${idproduto}/trocartaxa`);
};

export const fetchEvents = async sequencial => {
  return await axiosPrivate.get(`/event/${sequencial}/list`);
};

export const registerEvent = async event => {
  return await axiosPrivate.post(`/loja/evento/cadastro`, event);
};

export const editEvent = async (idevent, dataEvent) => {
  return await axiosPrivate.put(`/loja/evento/alterar/${idevent}`, dataEvent);
};

export const deleteTicketsProductsOrRecharges = async ({
  loja,
  idproduto_variacao,
}) => {
  return await axiosPrivate.delete(
    `/loja/${loja}/ingresso/deletar/${idproduto_variacao}`
  );
};

export const fetchSectors = async ({ idevent, loja }) => {
  return await axiosPrivate.get(`/loja/${loja}/setor/listar/${idevent}`);
};

export const registerSector = async ({ description, producer, idevent }) => {
  return await axiosPrivate.post(`loja/setor/cadastro`, {
    descricao: description,
    loja: producer,
    idproduto: idevent,
    limite_venda_cpf: 0,
  });
};

export const editSector = async ({ idevent, sectors, loja }) => {
  const url = `loja/setor/atualizar/${idevent}?loja=${encodeURIComponent(
    loja
  )}`;
  return await axiosPrivate.put(url, sectors);
};

export const deleteSector = async ({ idsector, loja }) => {
  return await axiosPrivate.delete(`loja/setor/deletar/${idsector}`, {
    params: { loja },
  });
};

export const createTickets = async ({ idevent, loja, type }) => {
  return await axiosPrivate.post(`loja/ingresso/cadastro`, {
    idproduto: idevent,
    loja,
    tipo: type,
  });
};

export const updateTickets = async ({ idevent, tickets }) => {
  return await axiosPrivate.put(`loja/evento/tickets/${idevent}`, tickets);
};

export const createVariationProduct = async ({
  idevent,
  idproduto_variacao,
  loja,
}) => {
  return await axiosPrivate.post(`loja/variacao_produto/cadastro`, {
    idproduto: idevent,
    idproduto_variacao,
    loja,
  });
};

export const deleteVariationProduct = async ({
  idproduto_variacao,
  loja,
  idvariacao_produto,
}) => {
  return await axiosPrivate.delete(
    `loja/${loja}/produto/variacao/${idproduto_variacao}/deletar/${idvariacao_produto}`
  );
};

export const changeStatusEvent = async ({ loja, idevent, status }) => {
  return await axiosPrivate.put(
    `loja/${loja}/produto/${idevent}/trocarstatus`,
    {
      status,
    }
  );
};
export const changeTicketsOnEventList = async ({ loja, variacoes }) => {
  return await axiosPrivate.post(`/loja/produto/configIngressos`, {
    loja,
    variacoes,
  });
};
export const addOrRemoveTemplates = async ({
  action,
  file,
  id,
  tipo,
  loja,
}) => {
  return await axiosPrivate.post(`/loja/pedido_item/template/${action}`, {
    file,
    id,
    tipo,
    scope: "INGRESSO",
    loja,
  });
};

export const getEventInfo = async ({ loja, idevent }) => {
  return await axiosPrivate.post(`loja/produto/${idevent}`, {
    loja,
  });
};

export const insertBulkTickets = async ({ loja, idevent, ticket, dates }) => {
  return await axiosPrivate.post(
    `loja/${loja}/produto/${idevent}/inserir_em_quantidade`,
    {
      datas: dates,
      ticket,
    }
  );
};

export const canChangeEventType = async ({ loja, idevent }) => {
  return await axiosPrivate.get(
    `/loja/evento/alterar/tipo/${idevent}?loja=${loja}`
  );
};

export const removeDateFromRecurringEvent = async ({ loja, idevent, date }) => {
  return await axiosPrivate.get(
    `/loja/evento/deletar/calendario/${idevent}?loja=${loja}&dthr_ingresso=${date}`
  );
};
